// Native details menus work without JS. Close on navigation, outside click and Escape.
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  for (const menu of document.querySelectorAll('.eh-header details[open]')) {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  for (const menu of document.querySelectorAll('.eh-header details[open]')) {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  }
});
